var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-card-container store-box"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t("payment.paymentDetails")))]), _c('b-form-radio-group', {
    staticClass: "mt-2 ml-3",
    attrs: {
      "modelValue": _vm.paymentMethodClick
    },
    on: {
      "change": _vm.changePaymentSelect
    }
  }, [_vm.tenantPrefernce && _vm.tenantPrefernce.paymentMethod && _vm.tenantPrefernce.paymentMethod.online ? _c('b-container', [_c('b-row', [_c('b-form-radio', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.onlinePaymentName,
      "name": "radio-size",
      "size": "lg"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-top": "-1px",
      "font-size": "20px"
    }
  }, [_vm._v("ONLINE")])])], 1)], 1) : _vm._e(), _vm.tenantPrefernce && _vm.tenantPrefernce.paymentMethod && _vm.tenantPrefernce.paymentMethod.cod ? _c('b-container', [_c('b-row', [_c('b-form-radio', {
    staticClass: "mt-2",
    attrs: {
      "value": "COD",
      "name": "radio-size",
      "size": "lg"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-top": "-1px",
      "font-size": "20px"
    }
  }, [_vm._v("ZELLE")])])], 1)], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }